<template>
  <div id="language-selector">
    <select v-if="show" v-model="selected">
      <option v-for="(label, langCode) in languages" :key="langCode" :value="langCode">{{ label }}</option>
    </select>
  </div>
</template>

<script>
  import i18n from '../plugins/i18n'

  export default {
    name: 'LanguageSelector',
    data() {
      return {
        languages: {},
        show: false,
        selected: ""
      }
    },
    methods: {
      changeLanguage(langCode) {
        this.$store.commit('language/setActiveLanguage', langCode);
      }
    },
    created() {
      let selected = this.$store.getters['language/getSelectedLanguage'];
      if (selected !== null) {
        this.$store.commit('language/setActiveLanguage', selected);
      }
      this.selected = this.$store.getters['language/getActiveLanguage'];
      this.languages = i18n.ListLanguages();
      this.show = Object.keys(this.languages).length > 1;
    },
    watch: {
      'selected' (to, from) {
        this.changeLanguage(to);
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue